import React from 'react';

import { Typography, Box } from '@material-ui/core';

import { useTranslation } from 'react-i18next';

import { QRCode, QRCodeWrapper, StoreImgWrapper } from './ReadyToStartSleepio.styles';

import { getPlatform } from '../../utils/platformHelpers';

import EmoCloudSleep from '@/assets/EmoCloudSleep.svg';
import AppStore from '@/assets/AppStore.svg';
import GooglePlay from '@/assets/GooglePlay.svg';
import { Platform } from '@/utils/productHelpers';
import { SLEEPIO_APP_STORE_URL, SLEEPIO_GOOGLE_PLAY_URL } from '@/pages/Onboarding/utils/constants';

export const ReadyToStartSleepio: React.FC = () => {
  const { t } = useTranslation();
  const platform = getPlatform();

  let storeLink;
  let title = t('coverage.sleepio.patient.download_sleepio_title');
  let subtitle1 = t('coverage.sleepio.patient.download_sleepio_subtitle_1');
  let subtitle2 = '';

  if (platform === Platform.Android) {
    storeLink = (
      <StoreImgWrapper href={SLEEPIO_GOOGLE_PLAY_URL}>
        <img
          alt="Play Store"
          src={GooglePlay}
        />
      </StoreImgWrapper>
    );
  } else if (platform === Platform.iOS) {
    storeLink = (
      <StoreImgWrapper href={SLEEPIO_APP_STORE_URL}>
        <img
          alt="App Store"
          src={AppStore}
        />
      </StoreImgWrapper>
    );
  } else {
    storeLink = (
      <QRCodeWrapper>
        <QRCode
          data-testid="qr-code"
          value={`${window.location.origin}/appstore/sleepio`}
        />
      </QRCodeWrapper>
    );
    title = t('coverage.sleepio.patient.download_sleepio_title_desktop');
    subtitle1 = t('coverage.sleepio.patient.download_sleepio_subtitle_1_desktop');
    subtitle2 = t('coverage.sleepio.patient.download_sleepio_subtitle_2_desktop');
  }

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
    }}
    >
      <Box sx={{ textAlign: 'center', width: '100%', paddingTop: 26 }}>
        <img
          alt="Emo Cloud Sleep"
          style={{ width: '206px' }}
          src={EmoCloudSleep}
        />
      </Box>
      <Typography variant="h2">{title}</Typography>
      <Typography style={{ paddingBottom: 16 }}>
        {subtitle1}
      </Typography>
      {storeLink}
      <Typography>{subtitle2}</Typography>
    </Box>
  );
};
